import { AuthSession } from './auth-session.model';
import { FastLoginSessionDto } from './fast-login.dto';
import { AuthResultDto } from './login.dto';

export class AuthMapper {
  static fromDto(dto: AuthResultDto): AuthSession {
    const expiresAt = Date.parse(dto.accessTokenExpiresAtUtc);

    return {
      token: dto.accessToken ?? '',
      refreshToken: dto.refreshToken || undefined,
      // An unparseable timestamp leaves the expiry unknown rather than NaN.
      expiresAt: Number.isNaN(expiresAt) ? undefined : expiresAt,
      user: {
        id: dto.userId,
        name: dto.fullName,
        email: dto.email,
      },
      mustChangePassword: dto.mustChangePassword,
      profileCompleted: dto.profileCompleted,
    };
  }

  static fromFastLoginDto(dto: FastLoginSessionDto): AuthSession {
    const expiresAt = Date.parse(dto.accessTokenExpiresAtUtc);

    return {
      token: dto.accessToken ?? '',
      refreshToken: dto.refreshToken || undefined,
      expiresAt: Number.isNaN(expiresAt) ? undefined : expiresAt,
      user: {
        id: dto.userId || undefined,
        name: dto.fullName || undefined,
        email: dto.email || undefined,
      },
      mustChangePassword: dto.mustChangePassword,
      profileCompleted: dto.profileCompleted,
    };
  }
}
